var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useToast } from 'shared/components';
import { noteSchemaInstanceMap } from 'constants/note-schemas';
import { useSaveNote } from '.';
import { useCopyForwardContext } from 'pages/Note/contexts';
import { outOfSyncErrorMessage } from 'constants/autosave';
import { useRef } from 'react';
import { useFlagEnabled } from 'flagging/hooks';
import { ToastErrorBox } from 'shared/components/features/ToastErrorBox';
/**
 * Packs together all the things related to saving and tracking state of save operations.
 */
export var useSaveForm = function (_a) {
    var schema = _a.schema, noteForm = _a.noteForm, noteId = _a.noteId, setNoteId = _a.setNoteId, appointmentId = _a.appointmentId, memberId = _a.memberId, outOfSyncDisclosure = _a.outOfSyncDisclosure, userId = _a.userId, _b = _a.canSave, canSave = _b === void 0 ? true : _b, debounceRef = _a.debounceRef;
    var saveQueued = useRef(false);
    var saveQueuingFlagEnabled = useFlagEnabled('ENABLE_SAVE_QUEUING');
    var toast = useToast();
    var copyForwardTemplate = useCopyForwardContext().copyForwardTemplate;
    var saveMutation = useSaveNote({
        onSuccess: function (data, variables) {
            if (!variables.id && data.id) {
                // we didn't send an id so assume it was a post.
                setNoteId(data.id);
            }
        },
        onError: function (error) {
            var _a, _b;
            if (error.message === outOfSyncErrorMessage) {
                outOfSyncDisclosure.onOpen();
            }
            else {
                var message_1 = (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message;
                toast({
                    status: 'error',
                    duration: 15000,
                    position: 'top',
                    render: function (_a) {
                        var onClose = _a.onClose;
                        return (_jsx(ToastErrorBox, { onClose: onClose, title: "Failed to save note:", message: message_1 }));
                    },
                });
            }
        },
        onSettled: function (data) {
            if (saveQueued.current) {
                saveDraftClick(data === null || data === void 0 ? void 0 : data.id);
                saveQueued.current = false;
            }
        },
    });
    var saveDraftClick = function (argNoteId) {
        var _a;
        (_a = debounceRef.current) === null || _a === void 0 ? void 0 : _a.cancel();
        if (canSave) {
            if (saveMutation.isLoading && saveQueuingFlagEnabled) {
                saveQueued.current = true;
            }
            else {
                var preparedForm = noteSchemaInstanceMap[schema].prepareFormForSave(noteForm);
                if (preparedForm.sessionInfo && copyForwardTemplate) {
                    preparedForm.sessionInfo.copyForward = copyForwardTemplate.id;
                }
                if (noteId || argNoteId) {
                    saveMutation.mutate(__assign(__assign({}, preparedForm), { id: noteId || argNoteId, noteSchema: schema }));
                }
                else {
                    saveMutation.mutate(__assign(__assign({}, preparedForm), { noteSchema: schema, rotomAppointmentId: appointmentId, rotomMemberId: memberId || '', userId: userId || '' }));
                }
            }
        }
    };
    var saveActionProps = {
        saveMutation: saveMutation,
        saveDraftClick: saveDraftClick,
    };
    return {
        saveActionProps: saveActionProps,
    };
};
